import React, { useContext, useEffect, useState } from 'react';
import styles from './ProfileSettings.module.scss';
import { withRouter } from 'react-router-dom';
import { Button, Modal, Alert } from 'esa-ui-library';
import {
	Header,
	Sidebar,
	SideMenu,
	PageContainer,
	Page,
	PageAuth,
	PageHeader,
	ActionContainer,
	AccountActions,
	LastActivity,
	CHANGE_REQUETS_MESSAGE,
	CHANGE_PASSWORD_TITLE,
	RESET_PASSWORD_TITLE,
	RESET_PASSWORD_MESSAGE,
	NO_USER_MESSAGE,
	PERMISSIONS,
} from '../..';
import { ProfileSettingsForm } from './components';
import { profilePages, profileRestricted, useStore, debounce, PropertyType } from '../../../common';
import { AuthContext } from '../../../logic';
import { isEmpty } from 'lodash';

export const ProfileSettingsComponent = (props: PropertyType): JSX.Element => {
	const [modalOpened, setModalOpened] = useState(false);
	const [resetDisabled, setResetDisabled] = useState(false);
	const [userInitiated, setUserInitiated] = useState(false);
	const [{ userId }, dispatch] = useStore();
	const { user, token, logout, setUser } = useContext(AuthContext);
	const { id } = props.match.params;
	const isCurrentUser = user?.id === id;
	const canResetPasswords = user?.permissions?.isSuperAdmin || user?.permissions[PERMISSIONS.canResetPasswords];
	const resetText = !isCurrentUser && canResetPasswords ? 'Reset' : 'Change';
	const modalTitle = !isCurrentUser && canResetPasswords ? RESET_PASSWORD_TITLE : CHANGE_PASSWORD_TITLE;

	useEffect(() => {
		if (!isEmpty(user) && id) {
			initUser();
		}
	}, [user, id]);

	const onSettingsSubmit = async () => {
		await dispatch('SETTINGS_SUBMIT', token);
		if (!isCurrentUser) return dispatch('USER_INIT', { token, id });
		dispatch('GET_UPDATED_USER', { token, setUser });
	};

	const initUser = async () => {
		await dispatch('USER_INIT', { token, id });
		debounce(() => setUserInitiated(true));
	};

	const onModalOpen = () => {
		setModalOpened(true);
	};

	const onModalClose = () => {
		setModalOpened(false);
	};

	const onResetEmailSubmit = () => {
		dispatch('RESET_EMAIL_SUBMIT', token);
		onModalClose();
		setResetDisabled(true);
		isCurrentUser && debounce(() => logout(), 3000);
	};

	const renderContent = () => (
		<>
			<PageContainer>
				<Sidebar dataId='account-sidebar' opened>
					<SideMenu
						options={
							user?.permissions?.isSuperAdmin || user?.permissions?.canViewUserDetails
								? profilePages
								: profileRestricted
						}
					/>
				</Sidebar>
				<Page>
					<PageHeader title='Profile Settings'>{!isCurrentUser ? <AccountActions /> : null}</PageHeader>
					<section className={styles.PageContent}>
						<LastActivity />
						<ProfileSettingsForm onSubmit={onSettingsSubmit} />
						{(isCurrentUser || canResetPasswords) && (
							<ActionContainer>
								<h5>{`${resetText} password`}</h5>
								<p>{CHANGE_REQUETS_MESSAGE}</p>
								<Button
									title={`${resetText} password`}
									small
									disabled={resetDisabled}
									onClick={onModalOpen}
									dataId='change-pass-button'
								/>
							</ActionContainer>
						)}
					</section>
				</Page>
			</PageContainer>
			{modalOpened && (
				<Modal danger title={modalTitle} submitLabel='Continue' onCancel={onModalClose} onSubmit={onResetEmailSubmit}>
					{RESET_PASSWORD_MESSAGE}
				</Modal>
			)}
		</>
	);

	return (
		<>
			<Header dataId='header' />
			<PageAuth permission={PERMISSIONS.canViewUser}>
				{userId && renderContent()}
				{userInitiated && !userId && <Alert className={styles.Alert} danger text={NO_USER_MESSAGE} />}
			</PageAuth>
		</>
	);
};

const ProfileSettings = withRouter(ProfileSettingsComponent);

export { ProfileSettings };
